import { applyDecorators } from '@nestjs/common';
import {
  ApiProperty,
  type ApiPropertyOptions,
} from '@nestjs/swagger/dist/decorators/api-property.decorator';
import { isApiEnv } from '../is-api-env';

export function DescribeProperty(options?: ApiPropertyOptions): PropertyDecorator {
  if (isApiEnv()) return applyDecorators(ApiProperty(options));

  return undefined as unknown as PropertyDecorator;
}
